// ToastRegistry.js - Centralized toast configuration

// Toast types (map to severity in ScoopToast)
export const TOAST_TYPES = {
    SUCCESS: 'success',
    ERROR: 'error',
    WARNING: 'warning',
    INFO: 'info',
}

// Default configuration per toast type
export const toastDefaults = {
    [TOAST_TYPES.SUCCESS]: {
        duration: 3000, // Quick positive feedback
    },
    [TOAST_TYPES.ERROR]: {
        duration: 6000, // Critical messages need more time
        persistent: false,
    },
    [TOAST_TYPES.WARNING]: {
        duration: 5000, // Ensure user awareness
    },
    [TOAST_TYPES.INFO]: {
        duration: 4000, // Comfortable reading time
    },
}

// Global toast system configuration
export const toastConfig = {
    maxVisible: 5, // Maximum simultaneous visible toasts
    position: 'bottom-left', // top-right, top-left, bottom-left, bottom-right
    stackDirection: 'up', // 'up' = new toasts stack upward, 'down' = stack downward
    gutter: 8, // Spacing between toasts (px)
}
